import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=822fd2e0&scoped=true"
import script from "./PersonEdit.vue?vue&type=script&lang=js"
export * from "./PersonEdit.vue?vue&type=script&lang=js"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&id=822fd2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822fd2e0",
  null
  
)

export default component.exports